module.exports = __webpack_public_path__ + "static/playfairdisplay-regular-adb9426d4379ba8a907259b24af2e46b.woff2";